import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Signup from './parts/Signup';

function Register() {
  return (
    <Container fluid className="h-100 mt-4">
      <Row className="mt-3">
        <Col>
          <Signup admin={true} />
        </Col>
      </Row>
    </Container>
  );
}

export default Register;
